var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pendingRevision)?_c('el-alert',{attrs:{"title":"Revision","show-icon":"","closable":false,"type":"warning"}},[_c('span',[_vm._v("You are editing page revision. Changes will not be published until you\n    submit this form.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }